<template>
  <PublicPageTemplate>
    <template v-slot:content>
      <TWLoadingSpinner v-if="loading" />
      <PublicPageHeader :title="$t('forgot.pageTitle')" />
      <div v-if="submitted" class="text-center mb-base">
        <i18n path="forgot.successDisplay" tag="p">
          <template v-slot:email>
            <b>{{ submittedEmail }}</b>
          </template>
        </i18n>
      </div>
      <form @submit.prevent="validateForm">
        <FloatingLabelInput
            type="text"
            @input="clearEmailErrorMessage"
            :has-error="emailErrorMessage"
            :placeholder="$t('forgot.emailAddress')"
            v-validate="'required|isTrimmedEmail'"
            v-model.trim="email"
            data-vv-name="email"
            :data-vv-as="$t('forgot.emailAddress')"
            data-vv-scope="forgot"
            data-test="forgot-email"
            data-hj-suppress
            data-ec="forgot"
            data-et="email_field"
        />
        <PublicPageValidationError :errorMessage="emailErrorMessage" />
        <PublicPageSubmitButton
            :text="$t('forgot.cta')"
            data-test="forgot-button"
            data-ec="forgot"
            data-et="forgot_button"
        />
      </form>
      <div class="text-center">
        <RouterLink
            :to="{ name: 'Login' }"
            class="mb-sm text-darkFont hover:text-primary active:text-darkFont font-normal"
            data-ec="forgot"
            data-et="login_link">
          {{ $t('forgot.login') }}
        </RouterLink>
      </div>
    </template>
  </PublicPageTemplate>
</template>

<script>
import { mapActions } from 'vuex';

import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';
import PublicPageTemplate from '@/components/tailwind/publicPages/PublicPageTemplate.vue';
import PublicPageHeader from '@/components/tailwind/publicPages/PublicPageHeader.vue';
import FloatingLabelInput from '@/components/tailwind/forms/FloatingLabelInput.vue';
import PublicPageSubmitButton from '@/components/tailwind/publicPages/PublicPageSubmitButton.vue';
import PublicPageValidationError from '@/components/tailwind/publicPages/PublicPageValidationError.vue';

export default {
  name: 'ForgotPassword',
  inject: {
    $validator: '$validator',
  },
  components: {
    FloatingLabelInput,
    TWLoadingSpinner,
    PublicPageTemplate,
    PublicPageHeader,
    PublicPageSubmitButton,
    PublicPageValidationError,
  },
  data() {
    return {
      email: null,
      loading: false,
      submitted: false,
      submittedEmail: null,
      appV1Url: process.env.VUE_APP_APPV1,
      emailErrorMessage: null,
    };
  },
  methods: {
    ...mapActions('user', [
      'FORGOT_PASSWORD',
    ]),
    clearEmailErrorMessage() {
      this.emailErrorMessage = null;
    },
    async validateForm() {
      const validated = await this.$validator.validateAll('forgot');

      if (!validated) {
        this.emailErrorMessage = this.errors.items[0].msg;
        return;
      }
      this.loading = true;
      this.FORGOT_PASSWORD({ email: this.email }).then(() => {
        this.submittedEmail = this.email;
        this.submitted = true;
        this.email = '';
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

